module.exports = __webpack_public_path__ + "img/nta-logo-white.560356e2.png";